import { createApi } from '@reduxjs/toolkit/query/react';
import { ReducerPaths } from '$store/constants/reducerPaths';
import { baseQuery } from '$store/utils/baseQuery';
import { getAllJobCategories } from './queries/get-all-job-categories';

export const jobCategoriesApi = createApi({
  reducerPath: ReducerPaths.JOB_CATEGORIES,
  baseQuery,
  tagTypes: ['JobCategories'],
  endpoints: (builder) => ({
    getAllJobCategories: getAllJobCategories(builder),
  }),
});

export const { useGetAllJobCategoriesQuery } = jobCategoriesApi;
